import { subscribeToEvent } from '../tools/event-subscribe';

export function focusFrequencyCollector(onData) {
  const startTime = Date.now();
  let lastFocusTime = null;
  const data = {
    focusDuration: 0,
    count: 0,
    frequency: 0,
  };

  function handleFocus() {
    const { focusDuration, count, frequency } = data;
    if (lastFocusTime) {
      if (focusDuration) {
        data.focusDuration = (focusDuration + (Date.now() - lastFocusTime)) / 2;
      } else {
        data.focusDuration = (Date.now() - lastFocusTime);
      }
    }

    data.count++;

    data.frequency = count / (Date.now() - startTime) * 1000 * 60;

    onData({ frequency, focusDuration });

    lastFocusTime = Date.now();
  }

  const subscriptions = [subscribeToEvent(window, 'focus', handleFocus, { capture: true })];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    const { focusDuration, count, frequency } = data;

    return count ? `${Math.round(focusDuration)}|${count}|${Math.round(frequency)}` : '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/focus-frequency.js